import { useBranchNavigation } from 'src/hooks/use-branch-navigation';
import { Select } from 'src/components/design-system/inputs/Select';
import { selectAvailableBranches } from 'src/store/selected-branch';
import useAppSelector from 'src/hooks/useAppSelector';
import { FC, ReactElement } from 'react';
import map from 'lodash/map';

export const BranchSelector: FC = (): ReactElement => {
    const branches = useAppSelector(selectAvailableBranches);
    const { activeBranchId, changeBranch } = useBranchNavigation();

    if (branches.length <= 1) return <></>;
    return (
        <Select
            className={'branch-selector'}
            value={activeBranchId}
            onSelect={b => changeBranch(b.value)}
            options={map(branches, b => ({ label: b.name, value: b.id }))}
        />
    );
};
